import { lenisRef } from "@/hooks/useLenis";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -10, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function scrollToSection(id) {
  scrollToId(id);
}
